import React, { useState, useRef } from 'react';
import { Download } from 'lucide-react';
import './Resume.css';

const Resume = () => {
  const [emailCopied, setEmailCopied] = useState(false);
  const resumeRef = useRef(null);
  const email = "Megha.1581@gmail.com";

  const handleEmailClick = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    }
  };

  const handleDownload = () => {
    window.print();
  };

  return (
    <div className="resume-a4">
      {/* Download Button */}
      <button 
        onClick={handleDownload}
        className="resume-download-btn"
        data-testid="download-resume-btn"
      >
        <Download size={18} />
        <span>Download PDF</span>
      </button>

      <div className="resume-paper" ref={resumeRef}>
        {/* Header */}
        <header className="resume-header">
          <h1 className="resume-name">Megha Mehta</h1>
          <p className="resume-title">Creative Head | Stylist | Visual Strategist</p>
          <div className="resume-contact-row">
            <span className="resume-contact-item">Mumbai, India</span>
            <button 
              onClick={handleEmailClick}
              className="resume-contact-item email-btn"
              title={emailCopied ? "Copied!" : "Click to copy email"}
            >
              {emailCopied ? "Copied!" : email}
            </button>
            <span className="resume-contact-item">LinkedIn: megha-mehta-203b46117</span>
          </div>
        </header>

        {/* Body - Two Column Layout */}
        <div className="resume-body">
          {/* Left Column - Sidebar */}
          <aside className="resume-sidebar">
            {/* Profile Image */}
            <div className="resume-section">
              <div className="resume-image-wrapper">
                <img 
                  src="https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/vjzsnag0_Screenshot%202026-01-19%20at%202.32.43%20PM.png" 
                  alt="Megha Mehta"
                  className="resume-profile-image"
                />
              </div>
            </div>

            {/* About */}
            <div className="resume-section">
              <h2 className="resume-section-title">About</h2>
              <p className="resume-about-text">
                Fashion creative leader with over a decade of experience shaping brand narratives across e-commerce, campaigns, celebrity styling, and film.
              </p>
              <p className="resume-about-text">
                Specializing in creating consistent visual systems that translate trends into scalable content strategies for modern fashion brands.
              </p>
            </div>

            {/* Education */}
            <div className="resume-section">
              <h2 className="resume-section-title">Education</h2>
              <div className="resume-edu-item">
                <p className="resume-edu-degree">Diploma in Commercial Arts</p>
                <p className="resume-edu-school">L.S. Raheja College, Mumbai</p>
              </div>
              <div className="resume-edu-item">
                <p className="resume-edu-degree">Diploma Level 2A</p>
                <p className="resume-edu-school">Alliance Française</p>
              </div>
            </div>
          </aside>

          {/* Right Column - Main Content */}
          <main className="resume-main">
            {/* Experience */}
            <div className="resume-section">
              <h2 className="resume-section-title">Experience</h2>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Bestseller India Pvt. Ltd.</h3>
                  <span className="resume-exp-date">Aug 2022 – Present</span>
                </div>
                <p className="resume-exp-role">Creative Head, J&J Junior, Vero Moda Girl and Selected</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Leading creative direction and content strategy for emerging brands, overseeing visual storytelling across e-commerce, digital platforms, and campaign ecosystems. Aligning creative output with commercial performance.
                </p>
              </div>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Bestseller India Pvt. Ltd.</h3>
                  <span className="resume-exp-date">2015 – 2022</span>
                </div>
                <p className="resume-exp-role">Head Stylist, Jack&Jones, Only & Sons, Produkt, AJIO B2B, J&J Junior, Vero Moda Girl</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Shaped the visual identity of multiple brands simultaneously, ensuring each retained a distinct yet commercially effective aesthetic. Increased sales potential by 70% through strategic content placement.
                </p>
              </div>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Freelance Stylist</h3>
                  <span className="resume-exp-date">Apr 2013 – Nov 2014</span>
                </div>
                <p className="resume-exp-role">Commercial & Entertainment Styling</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Styled Deepika Padukone for Garnier BB Cream TVC. Worked with brands including Snapdeal, Airtel, Pantene, KFC. Styled for 10+ national TV commercials.
                </p>
              </div>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Dharma Productions</h3>
                  <span className="resume-exp-date">Mar 2013 – Oct 2013</span>
                </div>
                <p className="resume-exp-role">Senior Stylist</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Assisted lead stylist for Humpty Sharma Ki Dulhania. Oversaw fittings, on-set styling, and led a team of junior stylists.
                </p>
              </div>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Payal Singhal</h3>
                  <span className="resume-exp-date">Dec 2012 – Jan 2013</span>
                </div>
                <p className="resume-exp-role">Freelance Design Consultant</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Designed prêt collection for Blenders Pride Fashion Week. Developed mood boards, color palettes, and styled campaign shoots.
                </p>
              </div>

              <div className="resume-exp-item">
                <div className="resume-exp-header">
                  <h3 className="resume-exp-company">Gavin Miguel</h3>
                  <span className="resume-exp-date">Aug 2011 – Nov 2013</span>
                </div>
                <p className="resume-exp-role">Freelance Design & Product Consultant</p>
                <p className="resume-exp-location">Mumbai</p>
                <p className="resume-exp-desc">
                  Designed prêt collection for Blenders Pride Fashion Week. Led the embroidery department.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Resume;
